// extracted by mini-css-extract-plugin
export default {"container":"breadCrumbs_container__pNo+K","disabled":"breadCrumbs_disabled__MJvSx"};